import qs from 'qs';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const createTransaction = async (clientId, selectedPayments, totalAmount) => (await requestFunnel.post('transactions', {
  clientId,
  selectedPayments,
  totalAmount
}, getOptions())).data;

export const changeTransactionSelectedPayments = async (transactionId, selectedPayments, totalAmount) => {
  return (await requestFunnel.patch(`transactions/${transactionId}`, {
    selectedPayments,
    totalAmount
  }, getOptions())).data;
};

export const setTransactionProvider = async (transactionId, provider) => (await requestFunnel.patch(`transactions/${transactionId}`, { provider }, getOptions())).data;

export const cancelTransaction = async transactionId => (await requestFunnel.patch(`transactions/${transactionId}`, { status: 'CANCELLED' }, getOptions())).data;

export const getClientsTransactions = async (clientId, transactionsIds) => {
  const options = getOptions();
  if (transactionsIds) {
    options.params = { transactionsIds };
  }
  return (await requestFunnel.get(`transactions?clientId=${clientId}`, options)).data;
};

export const processSingleTransaction = async (transactionId, receivedAmount, comment, bankEntriesIds, trustedIdNumbersWereAdded, provider) => {
  return (await requestFunnel.patch(`transactions/${transactionId}`, {
    receivedAmount,
    comment,
    bankEntriesIds,
    trustedIdNumbersWereAdded,
    provider
  }, getOptions())).data;
};

export const confirmGroupOfTransactions = async (transactionsIds, amount, comment, bankEntryId) => {
  return (await requestFunnel.patch('transactions', {
    transactionsIds,
    amount,
    comment,
    bankEntryId
  }, getOptions())).data;
};

export const getConfirmableTransactions = async () => (await requestFunnel.get('transactions/confirmable', getOptions())).data;

export const getConfirmedTransactions = async () => (await requestFunnel.get('transactions/confirmed', getOptions())).data;

export const getTransactionsHistory = async (filter, page, sort) => {
  const options = getOptions();
  options.params = { filter, page, sort };
  options.paramsSerializer = params => qs.stringify(params);
  return requestFunnel.get('transactions/find', options);
};

export const getConsignablePayments = async () => (await requestFunnel.get('transactions/consignable', getOptions())).data;

export const setTransactionsAsConsignable = async transactionsIds => (await requestFunnel.patch('transactions/consignable', { transactionsIds }, getOptions())).data;

export const setTransactionsAsAccounted = async transactionsIds => (await requestFunnel.patch('transactions/account', { transactionsIds }, getOptions())).data;

export const updateTransactionDebtDate = async (transactionId, date) => (await requestFunnel.patch(`transactions/${transactionId}/update-debt-date`, { date }, getOptions())).data;

export const getTransactionsProviders = async () => (await requestFunnel.get('transactions/providers', getOptions())).data;

export const createWalletEntryForInterestDiscount = async (amount, description, increase, transactionId, walletId, origin) => {
  const response = await requestFunnel.post(`transactions/${transactionId}/wallets-entries/${walletId}`, {
    amount,
    description,
    increase,
    origin
  }, getOptions());
  return response.data;
};

const getAuthorizationOptions = () => ({ headers: authenticationService.authHeader() });

export const uploadBcpTxt = async (file, useAuthToken) => {
  const options = useAuthToken ? getAuthorizationOptions() : { headers: {} };
  options.headers['Content-Type'] = 'multipart/form-data';
  options.timeout = 120000;
  const formData = new FormData();
  formData.append('file', file);
  return requestFunnel.post('transactions/upload-bcp-txt', formData, options);
};

export const createWalletEntryForDifferentPaymentSources = async (origin, increase, payments) => {
  const response = await requestFunnel.post('transactions/wallets-entries', {
    origin,
    increase,
    payments
  }, getOptions());
  return response.data;
};
